/* eslint-disable prefer-template */
import React from 'react';

function SpeakersList(props)
{

	const { webinarData, handleNavigate } = props;

	return (
		<div className='flexCol speakerhg'>
			{(webinarData?.speakersData && webinarData?.speakersData.length>0) ? webinarData?.speakersData.map((speaker, index) =>
				(<div className='flexCol pdngSM brdrBSM' key={index}>
					<div className='flexRow pdngSM '>
						<div className='flexAutoRow '>
							{speaker?.speakerImage?.publicUrl && speaker?.speakerImage?.key ? <img src={speaker?.speakerImage?.publicUrl + '/' + speaker?.speakerImage?.key} alt='profile' className='speakerProfile' /> : <img src='/images/avatar.svg' alt='profile' className='speakerProfile' />}
						</div>
						<div className='flexMinWidthCol pdngHSM'>
							<small className='capTxt'>{speaker.speakerName}</small>
							<small className='lGTxt'>{speaker.speakerEmail}</small>
							<small className='lGTxt capTxt'>{speaker.title}</small>
						</div>
						<div className='flexAutoRow  pointer gap8'>
							{speaker.facebookUrl && <img src='/icons/fb.svg' alt='fb' className='speakerIcons' onClick={() => handleNavigate(speaker.facebookUrl)} />}
							{speaker.twitterUrl && <img src='/webinar/tweet.svg' alt='twitter' className='speakerIcons' onClick={() => handleNavigate(speaker.twitterUrl)} />}
							{speaker.linkedinUrl && <img src='/icons/linkedin.svg' alt='linkedin' className='speakerIcons' onClick={() => handleNavigate(speaker.linkedinUrl)} />}
							{speaker.websiteUrl && <img src='/icons/website.svg' alt='website' className='speakerIcons' onClick={() => handleNavigate(speaker.websiteUrl)} />}
						</div>
					</div>
					{speaker.description && <p className='pdngHSM'>{speaker.description}</p>}
				</div>)
			)
				:<div className='flexCol aCntr jCntr gap16 speakerhg '>
					<img src='/images/speaker.svg' className='spImg' alt='noSpeaker' />
					<span>No speakers added yet !</span>
				</div>
			}
		</div>
	);
}

export default SpeakersList;